@for (field of fieldGroups.textInputs; track field) {
  <ziro-text [fieldId]="field"></ziro-text>
}
